export const messages = {
  authorizeToken: {
    success: "Token authorized successfully",
    error: "Token authorization failed",
  },
  login: {
    success: "Logged In Successfully.",
    error: "Failed to login.",
  },
  register: {
    success: "Account created successfully.",
    error: "Failed to register.",
  },
  forgotPassword: {
    success: "You are successfully forgot password.",
    error: "Failed to forgot password.",
  },
  verifyOTP: {
    success: "One Time Password verified successfully!",
    error: "Invalid One Time Password.",
  },
  resetPassword: {
    success: "Password reset successfully!",
    error: "Failed to reset password.",
  },
  logout: {
    success: "Logout successfully.",
    error: "Failed to logout.",
  },
  createCampus: {
    success: "Campus added successfully.",
    error: "Failed to add campus.",
  },
  editCampus: {
    success: "Campus updated successfully.",
    error: "Failed to edit campus.",
  },
  deleteCampus: {
    success: "Campus removed successfully.",
    error: "Failed to delete campus.",
  },
  listCampus: {
    success: "Campus list",
    error: "Failed to get campus list.",
  },
  singleCampus: {
    success: "",
    error: "Failed to get campus detail.",
  },
  getOrganization: {
    success: "",
    error: "Failed to get organization.",
  },
  updateOrganization: {
    success: "Organisation updated successfully",
    error: "Failed to update organization.",
  },
  createLocation: {
    success: "Location added successfully.",
    error: "Failed to add Location.",
  },
  editLocation: {
    success: "Location updated successfully.",
    error: "Failed to edit Location.",
  },
  deleteLocation: {
    success: "Location removed successfully.",
    error: "Failed to delete Location.",
  },
  listLocation: {
    success: "Location list",
    error: "Failed to get Location list.",
  },
  singleLocation: {
    success: "",
    error: "Failed to get Location detail.",
  },
  uploadImage: {
    success: "Image uploaded successfully",
    error: "Failed to Upload Image.",
  },
  resendOTP: {
    success: "",
    error: "Failed to Resend One Time Password.",
  },
  listAssembly: {
    success: "Assembly Point list",
    error: "Failed to get Assembly Point list.",
  },
  createAssembly: {
    success: "Assembly Point added successfully.",
    error: "Failed to add Assembly Point.",
  },
  deleteAssembly: {
    success: "Assembly Point removed successfully.",
    error: "Failed to delete Assembly Point.",
  },
  editAssembly: {
    success: "Assembly Points updated successfully.",
    error: "Failed to edit Assembly Point.",
  },
  listZone: {
    success: "Zone list",
    error: "Failed to get Zones.",
  },
  printingZone: {
    success: "Print successfully.",
    error: "Failed to Print.",
  },
  printingCourse: {
    success: "Print successfully.",
    error: "Failed to Print.",
  },
  copyQuest: {
    success: "Quest copied successfully.",
    error: "Failed to copy Quest.",
  },
  deleteQuest: {
    success: "Quest removed successfully.",
    error: "Failed to delete Quest.",
  },
  createZone: {
    success: "Zone added successfully.",
    error: "Failed to add Zone.",
  },
  deletedZone: {
    success: "Zone removed successfully.",
    error: "Failed to delete Zone.",
  },
  editZone: {
    success: "Zones updated successfully.",
    error: "Failed to edit Zone.",
  },
  getZoneFixture: {
    success: "Zone fixtures list.",
    error: "Failed to get zone fixtures.",
  },
  getZoneFixtureIncident: {
    success: "Zone fixtures incident list.",
    error: "Failed to get zone fixtures incident.",
  },
  deletedZoneFixture: {
    success: "Zone fixture removed successfully.",
    error: "Failed to delete Zone fixture.",
  },
  listFixtures: {
    success: "Prompts list.",
    error: "Failed to get Prompts.",
  },
  listZoneFixture: {
    success: "Prompts list",
    error: "Failed to get fixture list.",
  },
  createFixture: {
    success: "Prompts added successfully.",
    error: "Failed to add Prompts.",
  },
  updateFixture: {
    success: "Prompts updated successfully.",
    error: "Failed to edit Prompts.",
  },
  listTrainingVideo: {
    success: "Training videos list",
    error: "Failed to get training videos.",
  },
};